import { useRef, useState } from 'react';
import PropTypes from "prop-types";
import { Icon } from '@iconify/react';
import editFill from '@iconify/icons-eva/edit-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import mail20 from '@iconify/icons-eva/email-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';

// ----------------------------------------------------------------------

const UserMoreMenu = ({
  isApproval,
  onEdit,
  onDelete,
  onSendEmail,
}) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }} onClick={() => onEdit()}>
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {/* {
          !isApproval && (
            <MenuItem sx={{ color: 'text.secondary' }} onClick={() => onSendEmail()}>
              <ListItemIcon>
                <Icon icon={mail20} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Send email" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          )
        } */}

        <MenuItem sx={{ color: 'text.secondary' }} onClick={() => onDelete()}>
          <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        
      </Menu>
    </>
  );
}

UserMoreMenu.propTypes = {
  isApproval: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onSendEmail: PropTypes.func,
};

UserMoreMenu.defaultProps = {
  isApproval: false,
  onEdit: () => {},
  onDelete: () => {},
  onSendEmail: () => {},
};

export default UserMoreMenu;